module.exports = __webpack_public_path__ + "static/img/IT@2x.833ad2ea.jpg";